export default {
  helmetTitle: "{{ PATIENT_FIRST_NAME }}'s Visit Summary",
  navTitle: '{{ PREMIUM_VISIT_NAME }} video visit',
  visitInfo: {
    status: 'Video visit complete',
    title: "{{ PATIENT_FIRST_NAME }}'s visit summary",
  },
  defaultMinorNote: {
    protectedInfoNotice:
      'Due to the nature of this visit and the laws that protect under age patients, the patient must authorize the disclosure of information about their care before it can be viewed.',
    moreInfo: 'For more information, please call <0>{{ PHONE_NUMBER }}</0>.',
    thankYou: 'Thank you so much for trusting us with your care.',
    signature: '<0>Sincerely,</0><1>{{ PROVIDER_NAME }}</1>',
  },
  noteContent: {
    title: 'Treatment recommendations',
    missing: 'No visit summary has been entered for this visit.',
  },
  contactUs: {
    title: 'Need help?',
    subtitleMedicalRelatedQuestions: 'Medical-related questions',
    medicalQuestions: {
      title: 'For medical-related questions',
      medicalOption: {
        subtitle: 'Call patient support',
        title: '<0>{{ phoneNumber }}</0>   Available Mon-Sun, 9am-5pm EST',
      },
    },
    otherQuestions: 'All other questions',
    techSupportQuestions: 'Technical support questions',
    questionsOrConcerns:
      'If you have questions or concerns, scroll down to find the place to call or send your comment.',
    generalQuestions: {
      title: 'General account / billing questions',
      responseTime: 'Support will respond within 1 business day',
    },
  },
  disclaimer:
    'This visit summary is provided on the Solv platform for your convenience ' +
    'only and is based upon your completed telehealth visit. This visit summary is ' +
    "provided pursuant to your <0>consent</0> and Solv's <1>Terms of Service</1>. <2>Solv " +
    'is not the custodian of your medical records.</2> For further information, please ' +
    'reach out to Solv support at <3>{{ PREMIUM_VISIT_SUPPORT_EMAIL }}</3>.',
  discount: 'You saved {{ AMOUNT }} by using <0>{{MEMBERSHIP_NAME}}</0>',
};
